<template>
  <!-- 游戏相关礼包 -->
  <div class="gameGifts">
    <!-- 导航栏 -->
    <van-nav-bar :fixed="false" :placeholder="false" left-arrow @click-left="onBack">
      <template #title>
        <span>阿瓦隆之王{{gameId}}</span>
      </template>
      <template #left>
        <van-icon name="arrow-left" size=".7rem" color="#FF9D11" />
      </template>
    </van-nav-bar>
    <!-- 游戏-礼包内容 -->
    <div class="gameGift-wrapper">
      <div class="game-cont">
        <div class="game-icon-des">
          <div class="i-game">
            <img src="@assets/image/home/gameImg.png" alt="今日主推" />
          </div>
          <div class="game-des">
            <div class="game-name-size">
              <p>盗墓寻龙</p>
              <p>登录礼包</p>
            </div>
          </div>
        </div>
        <div class="game-down">
          <router-link v-if="index%2==0" tag="a" to="/activity/activitydetails">下载</router-link>
          <router-link v-else tag="a" to="/activity/activitydetails">开玩</router-link>
        </div>
      </div>
      <div class="gift-cont" v-for="(item,index) in 5" :key="index">
        <div class="gift-des">
          <p class="title">罗马帝国{{index+1}}00级登录礼包</p>
          <p class="cont">1.5倍经验药*1，50万金币*1，超值符文宝箱*1</p>
        </div>
        <span class="get" @click="getGift">领取</span>
      </div>
    </div>
    <!-- Dialog 弹出框组件 -->
    <van-overlay :show="show" />
    <div class="dialog" v-show="show" title="领取成功" width="70%">
      <p class="g-title">领取成功</p>
      <p class="g-code">
        <span>礼包码</span>:
        <span class="code">{{this.message}}</span>
      </p>
      <p class="confirm" @click="copyCode">
        <span>复制</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "gameGifts",
  components: {},
  data() {
    return {
      index: 1,
      message: "89h99a1", // 礼包码
      show: false, // 隐藏弹出弹框
      gameId: this.$route.query.id // 游戏is
    };
  },
  watch: {},
  computed: {},
  created() {
    console.log(this.$route.query.id);
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },
    // 领取礼包
    getGift() {
      this.show = true;
    },
    // 复制礼包码
    copyCode() {
      let that = this;
      this.$copyText(this.message).then(
        function(e) {
          that.$toast("复制成功");
          console.log(e);
          that.show = false;
        },
        function(e) {
          that.$toast("该浏览器不支持自动复制");
          console.log(e);
          that.show = false;
        }
      );
    }
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.gameGifts {
  width: 100%;
  height: 100vh;
  background-color: #f9f9f9;
  // background-color: skyblue;
  /deep/.van-nav-bar__title {
    font-weight: bold;
  }
  // 游戏-礼包内容
  .gameGift-wrapper {
    .boxShadow(1px);
    .borderRadius(0.5rem);
    background-color: #fff;
    width: 92%;
    margin: 0 auto;
    padding-bottom: 1rem;
    // 游戏
    .game-cont {
      .jc-between();
      padding: 0.5rem 0.3rem;
      padding-bottom: 0;
      .game-icon-des {
        display: flex;

        .i-game {
          width: 2rem;
          img {
            .img();
          }
        }
        .game-des {
          .flex-column();
          margin-left: 0.35rem;
          .game-name-size {
            p {
              &:nth-of-type(1) {
                font-size: 0.5rem;
              }
              &:nth-of-type(2) {
                .font-color();
                font-size: 0.3rem;
              }
            }
          }
          .dis-num {
            display: flex;
            margin-top: 0.1rem;
            span {
              color: #fff;
              background-color: #f00;
              font-size: 0.3rem;
              border-radius: 0.2rem;
              display: inline-block;
              padding: 0.03rem 0.2rem;
              margin-right: 0.2rem;
            }
          }
        }
      }
      .game-down {
        .theme-bg-color();
        border-radius: 0.2rem;
        padding: 0.1rem 0.4rem;
        a {
          color: #fff;
        }
      }
      &:first-child {
        margin-top: 0.5rem;
      }
    }
    // 礼包内容
    .gift-cont {
      width: 100%;
      padding: 0.3rem 0;
      .jc-between();
      .gift-des {
        width: 70%;
        padding-left: 0.3rem;
        p {
          &:nth-of-type(1) {
            font-size: 0.4rem;
          }
          &:nth-of-type(2) {
            font-size: 0.3rem;
            .font-color();
          }
          .ellipsis();
        }
      }
      .get {
        border-radius: 0.2rem;
        padding: 0.1rem 0.4rem;
        .theme-bd-color();
        .theme-color();
        margin-right: 0.3rem;
      }
    }
  }
  // 弹窗组件
  .dialog {
    .transform(fixed);
    width: 70%;
    background-color: #fff;
    z-index: 10;
    .borderRadius(0.3rem);
    .g-title {
      text-align: center;
      padding-top: 0.3rem;
    }
    .g-code {
      text-align: center;
      padding: 0.3rem;
    }
    .confirm {
      text-align: center;
      padding-bottom: 0.3rem;
      letter-spacing: 0.1rem;
      span {
        .theme-bg-color();
        .borderRadius(0.2rem);
        color: #fff;
        padding: 0.2rem 20%;
        display: inline-block;
      }
    }
  }
}
</style>